import Cookies from "js-cookie";
import config from "@/config";

export const USER_KEY = "user";
export const PROVIDER_TYPE_KEY = "providerType";

export const setUserInfo = (data) => {
  Cookies.set(USER_KEY, JSON.stringify(data), {
    expires: config.cookieExpires || 1,
  });
};

export const getUserInfo = () => {
  const data = Cookies.get(USER_KEY);
  if (data) return JSON.parse(data);
  else return false;
};

export const removeUserInfo = () => {
  Cookies.remove(USER_KEY);
};

export const setProviderType = (data) => {
  Cookies.set(PROVIDER_TYPE_KEY, data, { expires: config.cookieExpires || 1 });
};

export const getProviderType = () => {
  const type = Cookies.get(PROVIDER_TYPE_KEY);
  if (type) return type;
  else return false;
};

export const removeProviderType = () => {
  return Cookies.remove(PROVIDER_TYPE_KEY);
};
